import { z } from 'zod';
export const aiToolExecuteSchema = z.object({
    tool: z.string().min(1).max(200),
    params: z.record(z.unknown()).optional().default({}),
});
export const aiAgentCreateSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    apiKey: z.string().min(32).max(255),
    permissions: z.array(z.string()).optional(),
});
export const aiEventsQuerySchema = z.object({
    format: z.enum(['json', 'sse']).optional().default('json'),
    limit: z.coerce.number().int().min(1).max(500).optional().default(50),
    type: z.string().optional(),
});
export const aiSchemaQuerySchema = z.object({
    table: z.string().optional(),
    detailed: z.enum(['true', 'false']).optional().default('false').transform((v) => v === 'true'),
});
// --- Faz 2: Operational Memory ---
export const aiMemorySetSchema = z.object({
    value: z.string().min(1),
    category: z.string().min(1).max(50),
    summary: z.string().max(500).optional(),
    tags: z.string().max(500).optional(),
    priority: z.number().int().min(1).max(10).optional(),
    expiresInHours: z.number().positive().optional(),
});
// --- Conversations ---
export const aiConversationCreateSchema = z.object({
    title: z.string().max(255).optional(),
    context: z.record(z.unknown()).optional(),
});
export const aiMessageCreateSchema = z.object({
    role: z.enum(['user', 'assistant', 'system', 'tool']),
    content: z.string().optional(),
    toolCalls: z.array(z.object({
        tool: z.string(),
        params: z.unknown(),
        result: z.unknown(),
    })).optional(),
    toolName: z.string().max(200).optional(),
    tokensUsed: z.number().int().min(0).optional(),
});
// --- Tasks ---
export const aiTaskCreateSchema = z.object({
    type: z.string().min(1).max(100),
    description: z.string().min(1),
    params: z.record(z.unknown()).optional(),
    scheduledAt: z.string().datetime().optional(),
});
export const aiTaskStatusUpdateSchema = z.object({
    status: z.enum(['running', 'completed', 'failed', 'cancelled']),
    result: z.unknown().optional(),
    errorMessage: z.string().optional(),
});
// --- List queries (used by ai.controller) ---
export const aiToolsDbQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    limit: z.coerce.number().int().min(1).max(200).optional().default(50),
    search: z.string().optional(),
    category: z.string().optional(),
    plugin: z.string().optional(),
    danger: z.string().optional(),
});
export const aiToolsQuerySchema = z.object({
    category: z.string().optional(),
});
export const aiAuditLogQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(500).optional().default(50),
    agentId: z.coerce.number().int().positive().optional(),
    toolName: z.string().optional(),
    profileId: z.coerce.number().int().positive().optional(),
});
export const aiAuditStatsQuerySchema = z.object({
    range: z.enum(['24h', '7d', '30d']).optional().default('24h'),
    from: z.string().optional(),
    to: z.string().optional(),
    toolName: z.string().optional(),
});
export const aiMemoryListQuerySchema = z.object({
    category: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(500).optional().default(50),
});
export const aiConversationListQuerySchema = z.object({
    status: z.enum(['active', 'closed', 'archived']).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional().default(20),
    profileId: z.coerce.number().int().positive().optional(),
});
export const aiTaskListQuerySchema = z.object({
    status: z.enum(['pending', 'running', 'completed', 'failed', 'cancelled']).optional(),
    type: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(500).optional().default(50),
});
export const aiProfileListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    limit: z.coerce.number().int().min(1).max(200).optional().default(20),
    type: z.enum(['assistant', 'automation', 'api']).optional(),
    visibility: z.enum(['global', 'personal']).optional(),
    isActive: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
    isTemplate: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
    templateCategory: z.string().optional(),
    search: z.string().optional(),
});
export const aiSummarySearchQuerySchema = z.object({
    q: z.string().min(2).max(500),
    limit: z.coerce.number().int().min(1).max(200).optional().default(20),
});
/**
 * Query for the live NIM catalogue route — the single catalogue query surface
 * (the copilot twin was retired, #2603). `'true'` skips the TTL and forces an
 * upstream fetch.
 */
export const aiNimModelsQuerySchema = z.object({
    refresh: z.enum(['true', 'false']).optional().default('false'),
});
//# sourceMappingURL=ai.schema.js.map